const swiper7 = new Swiper('.swiper', {
    // Default parameters
    loop: true,
    loopedSlide: 3,
    // allowSlideNext: true,
    freeMode: false,
    initialSlide: 0,
    slidesPerView: 1,
    // centeredSlides: true,
    navigation: {
      nextEl: '.hero-room__swiper-button-next',
      prevEl: '.hero-room__swiper-button-prev',
    },
  });